import { Link } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useQuery, useSearch, useSearchContext } from "@sajari/react-hooks";
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import styled from "styled-components";
import "../../../../../styles/common.css";
import "../../../../../styles/responsive-common.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getCustomProducts } from "redux/services/Home/genericSearch";

interface productDetails {
  productName: string;
  price: string;
  discountedPrice: string;
  image: string;
}

interface SectionDetails {
  heading: string;
  subHeading: string;
  products: productDetails[];
}
const SaleComponent: React.FC<{ data: SectionDetails }> = ({ data }) => {
  const history = useHistory();
  const { query, setQuery } = useQuery();
  const { results = [] } = useSearch();
  const { searched } = useSearchContext();

  const handleCategoryChange = (categoryName: string) => {
    setQuery(categoryName);
    const destination =
      categoryName === "Footwear" ? "/footwear" : "/search-results";
    history.push({
      pathname: destination,
      search: `?${"q"}=${categoryName}`,
      state: {
        searched,
        results,
      },
    });
  };

  return (
    <SaleComponentWrapper>
      <FluidContainer>
        <SaleTitle>{data.heading}</SaleTitle>
        <ProductList>
          {data.products.map((item, index) => (
            <Product
              key={index}
              onClick={() => handleCategoryChange(item.productName)}
            >
              <ProductCard>
                <ProductImg>
                  <Image alt="exclusive-product-img" src={item.image} />
                </ProductImg>
                <SaleTitleWrapper>
                  <Title>{item.productName}</Title>
                </SaleTitleWrapper>
              </ProductCard>
            </Product>
          ))}
        </ProductList>
      </FluidContainer>
    </SaleComponentWrapper>
  );
};

const SaleComponentWrapper = styled.section`
  margin: 1rem;
  @media only screen and (max-width: 430px) {
    margin: 0rem;
  }
`;

const FluidContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 430px) {
    padding: 0rem;
  }
`;

const SaleTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const SaleTitle = styled.h3`
  font-size: 21px; /* Increase font size for better emphasis */
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
  text-align: left; /* Align text to the left */
  text-transform: uppercase; /* Uppercase the text */
`;

const StyledArrowForward = styled(ArrowForward)`
  color: #007bff;
  cursor: pointer;
`;

const ProductList = styled.ul`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(5, 1fr);
  margin: 0 auto;

  @media (max-width: 430px) {
    grid-template-columns: repeat(2, 1fr);

    gap: 10px;

    /* Hide the last item when screen width is 430px or lower */
    li:last-child {
      display: none;
    }
  }
`;

const Product = styled.li``;

const ProductCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: #fff;
  box-shadow: rgba(0, 30, 43, 0.3) 0px 4px 10px -4px;
  text-align: center;
  transition: border 150ms ease-in-out 0s, box-shadow;
  border-radius: 24px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(232, 237, 235);
`;

const ProductImg = styled.div`
  height: 230px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 600ms ease-in-out;
  margin: 3px;
  cursor: pointer;

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    content: "";
    display: none;
  }

  &:hover {
    &::before {
      display: block;
      background: rgba(0, 0, 0, 0.3);
    }
  }
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

const Title = styled.h4`
  width: fit-content;
  text-transform: uppercase;
  font-size: 16px;
  margin-left: 10px;
`;

const Divider = styled.div`
  width: 100%; /* Adjust width as needed */
  height: 1px;
  background-color: #ccc; /* Change color as needed */
  margin-top: 2px; /* Adjust margin as needed */
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  background-color: #007bff;
  color: #fff;
  padding: 10px 20px;
  border-radius: 5px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #0056b3;
  }
`;

export default SaleComponent;
